export default "__VITE_ASSET__97ca69a0__"